export const SALEHOO_TOOL_EMBED_MESSAGE_TYPE = 'salehoo-tool-height';
export const SALEHOO_TOOL_EMBED_ORIGIN_ATTRIBUTE = 'data-salehoo-tool-origin';
export const SALEHOO_TOOL_MAX_EMBED_HEIGHT = 50000;
